// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__9AA1l","categoryButton":"Categories_categoryButton__N9LI1","active":"Categories_active__gK3f0"};